import * as React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ApolloError } from 'apollo-boost';
import ResentTicketsForm from '../../../../../ResendTicketsForm';
import { useResendTickets } from '../../../../../Checkout/components/Checkout/hooks';
import { useSelector } from 'react-redux';
import { getOrder } from '../../../../../Checkout/store/order/selectors';
import { useTheme } from '../../../../../theme';
import { ResendTicketsStages } from '../../../../../ResendTicketsForm/types';
import { BaseButton } from '../../../../../BaseComponents';

const SendTickets: React.FC = props => {
	const order = useSelector(getOrder);

	const { resendStage, handleResendEmail, checkIsUnauthorizedError } = useResendTickets(order.id);
	const theme = useTheme('FlightInfoCard').TicketsModal;
	const { t } = useTranslation('ResendTicketsForm');
	const submitRef = useRef<() => void>();

	const isLoading = resendStage === ResendTicketsStages.Loading;

	const handleSubmit = async ({ email }: { email: string }) => {
		try {
			await handleResendEmail(email);
		} catch (error) {
			if (checkIsUnauthorizedError(error as ApolloError, ResendTicketsStages.Error)) {
				return {
					email: t(
						'To submit documents, log in to your account or use the email provided during the booking.'
					)
				};
			}
		}

		return undefined;
	};

	return (
		<div className={theme.sendTicketsContainer}>
			<ResentTicketsForm
				onSubmit={handleSubmit}
				defaultEmail={order.customer.values.find(({ name }) => name === 'email').value}
				className={theme.resend_wrapper}
				submitRef={submitRef}
			/>
			<div className={theme.buttons}>
				<BaseButton
					isLoading={isLoading}
					className={theme.button}
					variant="smallPrimary"
					onClick={() => submitRef.current?.()}
				>
					{t('Send')}
				</BaseButton>
			</div>
		</div>
	);
};

export default SendTickets;
